<template>
        <DepHeader
            v-if="departamento != null"
            :main-color="this.mainColor"
            :title="departamento.Nome"
            :name="currentdep"
            :cursos="departamento.Cursos"
            :urlimage="image"
            :show-apresentacao="showApresentacao"
            :show-destaques="showDestaques"
            :show-testemunhos="showTestemunhos"
            :colorClass="color"/>
        <div :class="{'testemunhosBackground': $route.name == 'testemunhos'}">
            <router-view></router-view>
        </div>
        <DepFooter
            :facebook="departamento.Facebook"
            :twitter="departamento.Twitter"
            :linkedin="departamento.Linkedin"
            :main-color="this.mainColor"
            :colorClass="color"
            :name="departamento.Nome"
            :faculdade="departamento.Faculdade"
            :email="departamento.Email"
            :contacto="departamento.Contacto"
            v-if="departamento != null"/>
</template>

<script>
import DepFooter from '../components/footer.vue';
import DepHeader from '../components/header.vue';
import logoarteedesign from '../assets/images/logosdepartamentos/logo_arte_design.png';

export default {
  name: "departamentoContainer",
  components: {
    DepFooter,
    DepHeader
  },
  data(){
    return {
      showDestaques: false,
      showTestemunhos: false,
      showApresentacao: false,
      departamento:null,
      color: '',
      mainColor:"",
      currentdep: '',
      image: "",
      images: {
        "arte-e-design": logoarteedesign
      }
    }
  },
  inject: ["mainColors"],
  created(){
    let parameters = this.$store.state.language != "en" ? "" : "&idioma=en";
    const request = `${process.env.VUE_APP_AXIOS}/departamento/${this.$route.params.id}?mindestaques=2${parameters}`;
    fetch(request)
        .then(response => response.json())
        .then(data => {
          this.departamento = data;
          this.currentdep = this.$route.params.id;
          this.color = this.departamento.Faculdade.name;
          this.$store.commit("setDepartamento",this.departamento);
          this.$store.commit("setColor",this.departamento.Faculdade.name);
          this.image = this.images[this.currentdep];
          this.mainColor = this.mainColors[this.departamento.Faculdade.name];
          this.showApresentacao = this.departamento?.Texto.length > 0 ||
              this.departamento.NumDestaques > 2 || this.departamento.Cursos.length > 0;
         })
        .catch(error => console.log(error));
    this.fetchDestaques();
    this.fetchTestemunhos();
  },
  methods: {
    fetchTestemunhos(){
      const request = `${process.env.VUE_APP_AXIOS}/departamento/${this.$route.params.id}/testemunhos?idioma=${this.$store.state.language}`;
      fetch(request)
          .then(response => response.json())
          .then(data => {
            this.showTestemunhos = data.length > 0;
          })
          .catch(error => console.log(error));
    },
    fetchDestaques(){
      const request = `${process.env.VUE_APP_AXIOS}/departamento/${this.$route.params.id}/destaques?idioma=${this.$store.state.language}`;
      fetch(request)
          .then(response => response.json())
          .then(data => {
            this.showDestaques = data.length > 0;
          })
          .catch(error => console.log(error));
    }
  }
}
</script>

<style scoped>
  .testemunhosBackground{
    background-color: #e9eaea;
  }
</style>